import { Box, Typography } from "@mui/material";
import DisplayLabel from "./base-components/Label";

const DisplayBool = ({
  label,
  value,
  options = { true: "Yes", false: "No" },
}) => {
  return (
    <Box className=" cursor-pointer hover:opacity-75 transition-opacity">
      <DisplayLabel text={label} />
      <Typography variant="h4">{options[value]}</Typography>
    </Box>
  );
};

export default DisplayBool;
